import * as React from 'react';

function SvgCash(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8 10a2 2 0 100-4 2 2 0 000 4z' />
			<path d='M0 4a1 1 0 011-1h14a1 1 0 011 1v8a1 1 0 01-1 1H1a1 1 0 01-1-1V4zm3 0a2 2 0 01-2 2v4a2 2 0 012 2h10a2 2 0 012-2V6a2 2 0 01-2-2H3z' />
		</svg>
	);
}

export default SvgCash;
